import React from 'react'
import react from 'react'
import { CiFaceFrown } from 'react-icons/ci'

type Props = {
    texto?: string
}

export const GridEmpty = React.memo(({ texto }: Props) => {
    return (

        <div className={`flex items-center justify-center w-full h-20 px-2 border border-gray-300 dark:border-gray-700 rounded-sm`}>
            <CiFaceFrown className={`w-10 h-10 text-red-500`} /> 
            <span className={`ml-2 font-mono font-bold dark:text-white text-black`}> {texto ? texto : 'Nenhuma informação encontrada'}</span>
        </div>
    )
})